import { render, staticRenderFns } from "./InternalFundingStatus.vue?vue&type=template&id=3bb8d619"
import script from "./InternalFundingStatus.vue?vue&type=script&lang=ts"
export * from "./InternalFundingStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports